import fetch from 'isomorphic-fetch';
import Config from '../../config/';
import { detect } from 'detect-browser';
const browser = detect();

const API = {
  data: {
    async getAll(obj) {
      let response = await fetch(
        `${Config.api}/api/summarybehaviour/${encodeURIComponent(JSON.stringify(obj))}`,
        {
          method: 'GET',
          headers: new Headers({
            Pragma: 'no-cache'
          })
        }
      );

      const status = response.status;
      let data = await response.json();
      return {
        data: data.response,
        status: status
      };
    },
    async handleDownloadSummaryReport(obj) {
      let response = await fetch(`${Config.api}/api/summarybehaviourdownloadsummaryexcel/${encodeURIComponent(JSON.stringify(obj))}`, {
        method: 'GET',
        'Content-Type': 'blob',
        headers: new Headers({ Pragma: 'no-cache' })
      });
      const status = response.status;
      if(status==200) {
        const blob = await response.blob();
        var a = document.createElement('a');
        var today = new Date();
        var todayString = today.getDate() + "_" + (today.getMonth()+1) 
        + "_" + today.getFullYear();

        if (browser.name == 'ie') {
          window.navigator.msSaveBlob(blob, 'datos_conducta_resumen_'+todayString+'.xlsx');
        } else {
          a.setAttribute('href', window.URL.createObjectURL(blob));
          a.setAttribute('target', '_blank');
          a.setAttribute('download', 'datos_conducta_resumen_'+todayString+'.xlsx');
          a.style.display = 'none';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
      }
    
      return {
        data: 'ok',
        status: status
      };
    },
    async handleDownloadNoProcessReport(obj) {
      let response = await fetch(`${Config.api}/api/summarybehaviourdownloadnoprocessexcel/${encodeURIComponent(JSON.stringify(obj))}`, {
        method: 'GET',
        'Content-Type': 'blob',
        headers: new Headers({ Pragma: 'no-cache' })
      });
      const status = response.status;

      if(status==200) {
        const blob = await response.blob();
        var a = document.createElement('a');
        var today = new Date();
        var todayString = today.getDate() + "_" + (today.getMonth()+1) 
        + "_" + today.getFullYear();

        if (browser.name == 'ie') {
          window.navigator.msSaveBlob(blob, 'datos_conducta_no_procesados_'+todayString+'.xlsx');
        } else {
          a.setAttribute('href', window.URL.createObjectURL(blob));
          a.setAttribute('target', '_blank');
          a.setAttribute('download', 'datos_conducta_no_procesados_'+todayString+'.xlsx');
          a.style.display = 'none';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
      }
    
      return {
        data: 'ok',
        status: status
      };
    }
  }
};
export default API;



// WEBPACK FOOTER //
// ./source/client/actions/summary_behaviour/api/index.js